import PHBG1 from '../../assets/images/backgrounds/background_contacto.webp'
import { Link } from 'react-router-dom'
import React, { useState } from 'react'
import { lapidas_api } from '../../__api-resolvers__/lapidas-api'

const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const Contact = () => {

    const [msg_valid, setmsg_valid] = useState(null);
    const [connecting_api, setconnecting_api] = useState(false);

    const form_subimted = async (event) => {
        event.preventDefault();

        const name = event.target.name.value;
        const email = event.target.email.value;
        const phone = event.target.phone.value;
        const subject = event.target.subject.value;
        const message = event.target.message.value;
        const emailSubject = subject.replace(/[\r\n]/g, ' ').trim();
        const body = `
            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#f3f6fa;padding:32px 16px;font-family:Arial,sans-serif;color:#202b3a;">
                <tr>
                    <td align="center">
                        <table role="presentation" width="600" cellpadding="0" cellspacing="0" border="0" style="width:100%;max-width:600px;background-color:#ffffff;border:1px solid #dce4ee;">
                            <tr>
                                <td style="padding:28px 36px;border-bottom:4px solid #0d4e91;">
                                    <img src="https://hahref.es/uploads/1685413156577logo_email_lapidas_pereiro.png" alt="Grupo Lápidas Pereiro" width="170" style="display:block;max-width:170px;height:auto;">
                                </td>
                            </tr>
                            <tr>
                                <td style="padding:36px 36px 28px;">
                                    <p style="margin:0 0 8px;color:#9b6b26;font-size:12px;font-weight:bold;letter-spacing:1px;text-transform:uppercase;">Formulario de contacto</p>
                                    <h1 style="margin:0;color:#163f6b;font-size:28px;line-height:34px;font-weight:700;">Nueva consulta recibida</h1>
                                    <p style="margin:16px 0 0;color:#52606d;font-size:16px;line-height:24px;">Un cliente ha enviado una consulta desde la web. Sus datos están disponibles a continuación.</p>
                                </td>
                            </tr>
                            <tr>
                                <td style="padding:0 36px 28px;">
                                    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #dce4ee;border-collapse:collapse;">
                                        <tr>
                                            <td style="width:35%;padding:13px 16px;border-bottom:1px solid #dce4ee;background-color:#f4f7fb;color:#52606d;font-size:14px;font-weight:bold;">Nombre</td>
                                            <td style="padding:13px 16px;border-bottom:1px solid #dce4ee;color:#202b3a;font-size:14px;">${escapeHtml(name)}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding:13px 16px;border-bottom:1px solid #dce4ee;background-color:#f4f7fb;color:#52606d;font-size:14px;font-weight:bold;">E-mail</td>
                                            <td style="padding:13px 16px;border-bottom:1px solid #dce4ee;color:#202b3a;font-size:14px;"><a href="mailto:${escapeHtml(email)}" style="color:#0d4e91;text-decoration:none;">${escapeHtml(email)}</a></td>
                                        </tr>
                                        <tr>
                                            <td style="padding:13px 16px;border-bottom:1px solid #dce4ee;background-color:#f4f7fb;color:#52606d;font-size:14px;font-weight:bold;">Teléfono</td>
                                            <td style="padding:13px 16px;border-bottom:1px solid #dce4ee;color:#202b3a;font-size:14px;">${escapeHtml(phone || 'No indicado')}</td>
                                        </tr>
                                        <tr>
                                            <td style="padding:13px 16px;background-color:#f4f7fb;color:#52606d;font-size:14px;font-weight:bold;">Asunto</td>
                                            <td style="padding:13px 16px;color:#202b3a;font-size:14px;">${escapeHtml(emailSubject)}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style="padding:0 36px 36px;">
                                    <p style="margin:0 0 9px;color:#52606d;font-size:14px;font-weight:bold;">Mensaje</p>
                                    <div style="padding:18px 20px;border-left:4px solid #b57a2b;background-color:#fafbfd;color:#202b3a;font-size:15px;line-height:24px;white-space:pre-wrap;">${escapeHtml(message || 'No se ha incluido ningún mensaje.')}</div>
                                </td>
                            </tr>
                            <tr>
                                <td style="padding:20px 36px;border-top:1px solid #dce4ee;background-color:#f4f7fb;color:#52606d;font-size:12px;line-height:18px;">Grupo Lápidas Pereiro · Consulta enviada desde <a href="https://grupolapidaspereiro.com" style="color:#0d4e91;text-decoration:none;">grupolapidaspereiro.com</a></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>`;

        try {
            setconnecting_api(true);

            await lapidas_api.sendNewEmail(
                'Grupo Lápidas Pereiro',
                'info@grupolapidaspereiro.com',
                `Nueva consulta web: ${emailSubject}`,
                body,
                '',
                '',
                'Grupo Lápidas Pereiro',
                'info@grupolapidaspereiro.com',
                email,
                name,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            );

            setmsg_valid({ value: true });
            event.target.reset();
        } catch (err) {
            setmsg_valid({ value: false });
            console.log('Error ', err);
        } finally {
            setconnecting_api(false);
        }
    }
    return (
        <>
            <div className="stricky-header stricked-menu main-menu">
                <div className="sticky-header__content"></div>
            </div>

            <section className="page-header">
                <div className="page-header__bg background_image_services" style={{ backgroundImage: `url(${PHBG1})` }}></div>
                <div className="container">
                    <ul className="thm-breadcrumb list-unstyled">
                        <li><Link to="/">Home</Link></li>
                        <li>/</li>
                        <li><span>Contacto</span></li>
                    </ul>
                    <h2>Contacto</h2>
                </div>
            </section>
            <section className="contact-one">
                <div className="container">
                    <div className="block-title text-center">
                        <p>Contacta con nosotros</p>
                        <h2>Envíenos su Consulta.</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="contact-one__content">
                                <p>Puedes contactar con nosotros a traves del siguiente formulario, o bien con los datos de contacto siguientes.</p>
                                <div className="contact-one__box">
                                    <i className="pylon-icon-telephone"></i>
                                    <div className="contact-one__box-content">
                                        <h4>Llámanos</h4>
                                        <Link to="tel:+34986295958">+34 986 29 59 58</Link>
                                    </div>
                                </div>
                                <div className="contact-one__box">
                                    <i className="pylon-icon-email1"></i>
                                    <div className="contact-one__box-content">
                                        <h4>Contacta por E-mail</h4>
                                        <Link to="/contact">info@grupolapidaspereiro.com</Link>
                                    </div>
                                </div>
                                <div className="contact-one__box">
                                    <i className="pylon-icon-pin1"></i>
                                    <div className="contact-one__box-content">
                                        <h4>Visita nuestras instalaciones</h4>
                                        <Link to="https://goo.gl/maps/MbFgjzKDoWYcAj4A8">Av. Castrelos 85. 36210 Vigo</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <form method="post" className="contact-one__form" onSubmit={form_subimted}>
                                <div className="row low-gutters">
                                    <div className="col-md-6">
                                        <input type="text" placeholder="Tu nombre" name="name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="email" placeholder="E-mail" name="email" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" placeholder="Teléfono" name="phone" />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" placeholder="Asunto" name="subject" required />
                                    </div>
                                    <div className="col-md-12">
                                        <textarea name="message" placeholder="Escribe un mensaje"></textarea>
                                        {msg_valid &&
                                            <>
                                                {msg_valid.value ?
                                                    <p className="message-ok">Tu mensaje ha sido enviado, gracias.</p>
                                                    :
                                                    <p className="message-error">Tu mensaje no ha podido ser enviado, inténtelo de nuevo más tarde.</p>
                                                }
                                            </>
                                        }
                                        {!msg_valid && <button className="thm-btn" type="submit" disabled={connecting_api}>Enviar</button>}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <div className="google-map__home-two">
                <iframe title="template google map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2955.2234442831596!2d-8.731828499999999!3d42.209668799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2589e5e127744d%3A0xfbcdfb0edbb9da7e!2zTMOhcGlkYXMgUGVyZWlyw7M!5e0!3m2!1ses!2sec!4v1677188789121!5m2!1ses!2sec" className="map__home-two" allowFullScreen></iframe>
            </div>
        </>
    )
}

export default Contact